<template>
  <div
    class="s-icon-comp"
    :class="[
              {'s-icon-comp-circle' : circle},
              {'s-iconimage-comp-circle' : circle && iconImage},
              {'s-icon-comp-roundsquare' : roundsquare},
              {'s-tooltip' : tooltip !== ''},
              {'s-tooltip-left' : tooltipLeft },
              {'s-tooltip-right' : tooltipRight },
              {'s-tooltip-top' : tooltipTop },
              {'s-tooltip-white' : tooltipWhite },
              ]"
    :data-tooltip="tooltip"
  >
    <i v-if="iconFont != ''" class="s-icon" :class="iconFont"></i>

    <img v-if="iconImage != ''" :class="imgClass" :src="require(`@/assets/images/${iconImage}`)" />

  </div>
</template>

<script>
export default {
  props: {
    imgClass: {
      type: String,
      default: "",
    },
    iconImage: {
      type: String,
      default: "",
    },
    iconFont: {
      type: String,
      default: "",
    },
    // use to create circle style selection.
    circle: {
      type: Boolean,
      default: false,
    },
    roundsquare: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "",
    },
    tooltipLeft: {
      type: Boolean,
      default: false,
    },
    tooltipRight: {
      type: Boolean,
      default: false,
    },
    tooltipTop: {
      type: Boolean,
      default: false,
    },
    tooltipWhite: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  }
};
</script>
